module.exports = __webpack_public_path__ + "img/side-banner_event.527ab30d.jpg";